import React from 'react';
import { Link } from 'react-router-dom';
import Counter from '../Counter';

const WhyUs = () => {
  return (
    <section id="why-us" className="why-us section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Why Us</h2>
        <p>We combine technical depth with a clear process so your projects stay on track and on budget.</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row g-4">
          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
            <div className="feature-card">
              <div className="icon-wrapper">
                <i className="bi bi-palette-fill"></i>
              </div>
              <h4>Technical Excellence</h4>
              <p>Our engineers hold certifications in AWS, Azure, and modern frameworks. We follow industry standards and security best practices on every engagement.</p>
              <div className="feature-stats">
                <Counter end={95} duration={2} suffix="%" />
                <span className="stat-label">% Client Satisfaction</span>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
            <div className="feature-card">
              <div className="icon-wrapper">
                <i className="bi bi-graph-up-arrow"></i>
              </div>
              <h4>Proven Results</h4>
              <p>We have delivered enterprise applications, cloud migrations, and integration platforms for startups and Fortune 500 companies alike, with measurable ROI and uptime.</p>
              <div className="feature-stats">
                <Counter end={200} duration={2} suffix="%" />
                <span className="stat-label">% ROI Increase</span>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
            <div className="feature-card">
              <div className="icon-wrapper">
                <i className="bi bi-award-fill"></i>
              </div>
              <h4>Expert Team</h4>
              <p>Our team includes solution architects, senior developers, and DevOps specialists who stay current with the latest technologies and delivery methodologies.</p>
              <div className="feature-stats">
                <Counter end={50} duration={2} suffix="+" />
                <span className="stat-label">Awards Won</span>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-lg-6" data-aos="fade-right" data-aos-delay="200">
            <div className="feature-showcase">
              <img src="/images/illustration-14.webp" alt="Creative Process" className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-6" data-aos="fade-left" data-aos-delay="300">
            <div className="feature-content">
              <h3>Why Leading Brands Choose Us</h3>
              <p className="lead">We align technology decisions with your business goals so every solution is scalable, maintainable, and ready for future growth.</p>

              <div className="feature-list">
                <div className="feature-item" data-aos="fade-up" data-aos-delay="400">
                  <div className="feature-icon">
                    <i className="bi bi-check-circle-fill"></i>
                  </div>
                  <div className="feature-text">
                    <h5>Solution-First Approach</h5>
                    <p>We start with your objectives and constraints, then design architecture and delivery plans that fit your timeline and budget.</p>
                  </div>
                </div>

                <div className="feature-item" data-aos="fade-up" data-aos-delay="450">
                  <div className="feature-icon">
                    <i className="bi bi-check-circle-fill"></i>
                  </div>
                  <div className="feature-text">
                    <h5>Data-Driven Delivery</h5>
                    <p>Clear milestones, regular demos, and transparent reporting keep stakeholders informed and projects on track.</p>
                  </div>
                </div>

                <div className="feature-item" data-aos="fade-up" data-aos-delay="500">
                  <div className="feature-icon">
                    <i className="bi bi-check-circle-fill"></i>
                  </div>
                  <div className="feature-text">
                    <h5>Dedicated Support</h5>
                    <p>Post-launch support and maintenance packages ensure your systems stay secure, updated, and performing at their best.</p>
                  </div>
                </div>
              </div>

              <div className="cta-wrapper">
                <Link to="/contact" className="btn btn-primary">Start Your Project</Link>
                <Link to="/portfolio" className="btn btn-outline">View Portfolio</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
